var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderForm-container" },
    [
      _c(
        "el-form",
        {
          ref: "orderForm",
          staticClass: "form-container",
          attrs: {
            model: _vm.orderForm,
            rules: _vm.rules,
            autocomplete: "on",
            "label-position": "left",
            size: "mini",
          },
        },
        [
          _c(
            "sticky",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                "z-index": 10,
                "class-name": "sub-navbar",
                title:
                  "Order " +
                  _vm.orderForm.orderId +
                  " - " +
                  _vm.orderForm.orderStatus,
              },
            },
            [
              !this.isAdmin()
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "mini" },
                      on: { click: _vm.downloadReport },
                    },
                    [_vm._v(" Download PDF ")]
                  )
                : _vm._e(),
              !this.isAdmin()
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "mini" },
                      on: { click: _vm.viewHistory },
                    },
                    [_vm._v(" Order History ")]
                  )
                : _vm._e(),
              _vm.orderForm.orderTypeNavigation &&
              (this.isAdmin() || this.isClientSuperUser())
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          "/orders/detail-tree/" +
                          _vm.orderForm.orderId +
                          "/" +
                          (_vm.orderForm.orderTypeNavigation.productGroup || 0),
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-inline": "10px",
                            display: "inline",
                          },
                          attrs: { type: "text", size: "mini" },
                        },
                        [_vm._v(" Details Tree ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.isAdmin()
                ? _c(
                    "router-link",
                    { attrs: { to: "/orders/copy/" + _vm.orderForm.orderId } },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-right": "10px",
                            display: "inline",
                          },
                          attrs: { type: "text", size: "mini" },
                        },
                        [_vm._v(" Copy Order ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.isAdmin() || _vm.isClientSuperUser()
                ? _c(
                    "el-dropdown",
                    {
                      staticStyle: { "margin-left": "10px" },
                      on: { command: _vm.handleReportMenuCommand },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dropdown",
                            fn: function () {
                              return [
                                _c(
                                  "el-dropdown-menu",
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "v" } },
                                      [_vm._v("Quick View")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "h" } },
                                      [_vm._v("Order History")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "q" } },
                                      [_vm._v("QA View")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "j" } },
                                      [_vm._v("JSON View")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "d" } },
                                      [_vm._v("Latest PDF")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "x" } },
                                      [_vm._v("Download XML")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "r" } },
                                      [_vm._v("Regenerate PDF")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        staticClass: "disabled",
                                        attrs: { divided: "" },
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v("-- Freddie Mac --"),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "fr" } },
                                      [_vm._v("Freddie Mac Status Page")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "f" } },
                                      [_vm._v("View Freddie Mac JSON")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "er" } },
                                      [_vm._v("Download Eligibility Report")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "egr" } },
                                      [_vm._v("Regenerate Eligibility Report")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        staticClass: "disabled",
                                        attrs: { divided: "" },
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v("-- Fannie Mae --"),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "fm" } },
                                      [_vm._v("Fannie Mae Status Page")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "fmj" } },
                                      [_vm._v("View Fannie Mae JSON")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "fmer" } },
                                      [_vm._v("Download Eligibility Report")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "fmegr" } },
                                      [_vm._v("Regenerate Eligibility Report")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "ljr" } },
                                      [_vm._v("App Response JSON")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3626081154
                      ),
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "secondary" } },
                        [
                          _vm._v(" Reports"),
                          _c(
                            "el-icon",
                            { staticClass: "el-icon--right" },
                            [_c("arrow-down")],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.isAdmin() || _vm.isClientSuperUser()
                ? _c(
                    "el-dropdown",
                    {
                      staticStyle: { "margin-left": "10px" },
                      on: { command: _vm.handleEditMenuCommand },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "dropdown",
                            fn: function () {
                              return [
                                _c(
                                  "el-dropdown-menu",
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "createChangeStatus",
                                        },
                                      },
                                      [_vm._v("Change Order Status")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: { command: "createFixRequest" },
                                      },
                                      [_vm._v(" Cubicasa Fix Request")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "Exterior",
                                          divided: "",
                                        },
                                      },
                                      [_vm._v("Exterior")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Interior" } },
                                      [_vm._v("Interior")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Floors" } },
                                      [_vm._v("Floors")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "PhotoTable" } },
                                      [_vm._v("Photo Table")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Photos" } },
                                      [_vm._v("Photos")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "UploadPhoto" } },
                                      [_vm._v("Upload Photo")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "ReplacePhoto" } },
                                      [_vm._v("Replace Photo")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "DeletePhoto" } },
                                      [_vm._v("Delete Photo")]
                                    ),
                                    _vm.showBlazor
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: "OrderBlazor",
                                              divided: "",
                                            },
                                          },
                                          [_vm._v("Order")]
                                        )
                                      : _vm._e(),
                                    _vm.showBlazor
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: "PropertyBlazor",
                                            },
                                          },
                                          [_vm._v("Property")]
                                        )
                                      : _vm._e(),
                                    _vm.showBlazor
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: "FeaturesBlazor",
                                            },
                                          },
                                          [_vm._v("Features")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Structure" } },
                                      [_vm._v("Structure")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Site Amenity" } },
                                      [_vm._v("Site Amenity")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Car Storage" } },
                                      [_vm._v("Car Storage")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Utility" } },
                                      [_vm._v("Utility")]
                                    ),
                                    _vm.showBlazor
                                      ? _c(
                                          "el-dropdown-item",
                                          { attrs: { command: "HUDBlazor" } },
                                          [_vm._v("HUD Menu")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "Units",
                                          divided: "",
                                        },
                                      },
                                      [_vm._v("Units")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Unit Floors" } },
                                      [_vm._v("Unit Floors")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "Unit Rooms" } },
                                      [_vm._v("Unit Rooms")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "cfi" } },
                                      [_vm._v("Supporting Documents")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2236886439
                      ),
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "secondary" } },
                        [
                          _vm._v(" Edit Menu"),
                          _c(
                            "el-icon",
                            { staticClass: "el-icon--right" },
                            [_c("arrow-down")],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isCompleted
                ? _c(
                    "div",
                    {
                      staticStyle: { "margin-left": "10px", display: "inline" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.cancelForm },
                        },
                        [_vm._v(" Close ")]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticStyle: { "margin-left": "10px", display: "inline" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v(" Save ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.cancelForm },
                        },
                        [_vm._v(" Close ")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "dialog-view-edit-report",
              attrs: {
                title:
                  "Edit " +
                  _vm.sectionGroup +
                  " " +
                  _vm.sectionName +
                  " - " +
                  _vm.orderForm.orderId,
                visible: _vm.dialogEditReportVisible,
                width: "90%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogEditReportVisible = $event
                },
                close: _vm.handleCloseEditor,
              },
            },
            [
              _c("iframe", {
                staticStyle: { width: "100%", height: "70vh" },
                attrs: { src: _vm.sectionURL },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "ca-cards" },
            [
              _c("OrderInformation", {
                key: "" + (_vm.componentKey + "OI"),
                staticClass: "ca-card",
                attrs: { isEdit: _vm.isEdit },
                model: {
                  value: _vm.orderForm,
                  callback: function ($$v) {
                    _vm.orderForm = $$v
                  },
                  expression: "orderForm",
                },
              }),
              _c("OrderContact", {
                key: "" + (_vm.componentKey + "OC"),
                staticClass: "ca-card",
                attrs: { isEdit: _vm.isEdit },
                model: {
                  value: _vm.orderForm,
                  callback: function ($$v) {
                    _vm.orderForm = $$v
                  },
                  expression: "orderForm",
                },
              }),
              _c("OrderProperty", {
                key: "" + (_vm.componentKey + "OP"),
                staticClass: "ca-card",
                attrs: { isEdit: _vm.isEdit },
                on: { "update-order": _vm.updateData },
                model: {
                  value: _vm.orderForm,
                  callback: function ($$v) {
                    _vm.orderForm = $$v
                  },
                  expression: "orderForm",
                },
              }),
              _c("VendorCreate", {
                ref: "VendorCreateRef",
                staticClass: "ca-card",
                attrs: { disableAssignVendorCTA: _vm.newVendor === null },
                on: {
                  "update-vendor": _vm.updateVendor,
                  "update-new-vendor": _vm.getNewVendor,
                  updateData: _vm.updateData,
                },
                model: {
                  value: _vm.orderForm,
                  callback: function ($$v) {
                    _vm.orderForm = $$v
                  },
                  expression: "orderForm",
                },
              }),
              _vm.showAvmSummary
                ? _c("AvmDetail", {
                    key: "" + (_vm.componentKey + "OA"),
                    staticClass: "ca-card",
                    attrs: { isEdit: _vm.isEdit, "v-model": _vm.orderForm },
                    on: { viewReport: _vm.handleViewReport },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title("JSON"),
            visible: _vm.dialogJsonVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogJsonVisible = $event
            },
          },
        },
        [
          _c("VueJsonViewer", {
            attrs: {
              value: _vm.getJson(),
              "expand-depth": 20,
              copyable: "",
              boxed: "",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title("JSON Freddie Mac"),
            visible: _vm.dialogJsonFreddieMacVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogJsonFreddieMacVisible = $event
            },
          },
        },
        [
          _c("VueJsonViewer", {
            attrs: {
              value: _vm.getJsonFreddieMacData(),
              "expand-depth": 20,
              copyable: "",
              boxed: "",
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title("History"),
            visible: _vm.dialogHistoryVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogHistoryVisible = $event
            },
          },
        },
        [
          _c("OrderHistoryTable", {
            attrs: { list: _vm.orderHistory, loading: _vm.getListLoading() },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-view-report",
          attrs: {
            title: _vm.title("View Report"),
            visible: _vm.dialogViewReportVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogViewReportVisible = $event
            },
          },
        },
        [
          _c("OrderViewReport", {
            attrs: {
              report: _vm.orderViewReport,
              loading: _vm.getListLoading(),
              label: "Capture Report Preview " + _vm.orderForm.orderId,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-view-report",
          attrs: {
            title: _vm.title("View QA Report"),
            visible: _vm.dialogViewQAVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogViewQAVisible = $event
            },
          },
        },
        [
          _c("OrderViewReport", {
            attrs: {
              report: _vm.orderQAReport,
              loading: _vm.getListLoading(),
              label: "Capture QA Report " + _vm.orderForm.orderId,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-view-report",
          attrs: {
            title: _vm.title("View Freddie Mac Report"),
            visible: _vm.dialogViewFreddieMacVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogViewFreddieMacVisible = $event
            },
          },
        },
        [
          _c("OrderViewReport", {
            attrs: {
              report: _vm.orderFreddieMacReport,
              loading: _vm.getListLoading(),
              label: "Capture QA Report " + _vm.orderForm.orderId,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-confirm-vendor-fee",
          attrs: {
            "close-on-click-modal": false,
            title: "Confirm New Vendor - " + _vm.orderForm.orderId,
            visible: _vm.dialogConfirmVendorFee,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogConfirmVendorFee = $event
            },
            close: _vm.closeModal,
          },
        },
        [
          _c("VendorData", {
            attrs: {
              vendor: _vm.newVendor,
              order: _vm.orderForm,
              hideFee: false,
            },
          }),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.handleAssignVendor(_vm.newVendorId)
                    },
                  },
                },
                [_vm._v(" Save ")]
              ),
              _c(
                "el-button",
                { attrs: { type: "warning" }, on: { click: _vm.closeModal } },
                [_vm._v(" Cancel ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Floorplan Fix Request",
            visible: _vm.dialogFixRequestVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFixRequestVisible = $event
            },
          },
        },
        [
          _c("FixRequestDialog", {
            attrs: {
              value: _vm.fixRequest,
              dialogVisible: _vm.dialogFixRequestVisible,
              copyable: "",
              boxed: "",
            },
            on: { close: _vm.handleFixRequestDialogClose },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Change Order Status",
            visible: _vm.dialogChangeStatusVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogChangeStatusVisible = $event
            },
          },
        },
        [
          _c("ChangeStatus", {
            attrs: {
              value: _vm.changeStatus,
              dialogVisible: _vm.dialogChangeStatusVisible,
              copyable: "",
              boxed: "",
            },
            on: { close: _vm.handleChangeStatusDialogClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }